import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import axios from 'axios';

import './Analytics.css'

const Analytics = () => {
    const pathNames = ['/SAPAcademy/Courses', '/SAPAcademy/LearningPaths', '/SAPAcademy/Testimonials', '/SAPAcademy/Experts', '/SAPAcademy/KeyStatistics', '/SAPAcademy/Feedback'];
    const [totalViews, setTotalViews] = useState(0);
    const [totalUserViews, setTotalUserViews] = useState(0);
    const [toggleAnalytics, setToggleAnalytics] = useState(false);
    const location = useLocation();

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    let loggedInEnterpriseId = '';
    if (activeAccount)
        loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

    const sapPagesAnalytics = () => {
        axios.post('https://atci.lkm.eitacademy.accenture.com/ips-apis/analytics', {
            enterprise_id: loggedInEnterpriseId
        },
            {
                headers: {
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => {
                getAnalytics();
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const getAnalytics = () => {
        axios.get('https://atci.lkm.eitacademy.accenture.com/ips-apis/analytics',
            {
                headers: {
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => {
                setTotalViews(response.data.totalViews);
                setTotalUserViews(response.data.totalUniqueUsers);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    useEffect(
        () => {
            if (process.env.NODE_ENV === 'production' && loggedInEnterpriseId !== '') {
                if (pathNames.includes(location.pathname) && location.pathname !== '/') {
                    setToggleAnalytics(true);
                    sapPagesAnalytics();
                }
                else
                    setToggleAnalytics(false);
            }
        },
        [location.pathname]
    );

    return (
        <>
            {toggleAnalytics && <div className='sap_views_count'>
                <img src={process.env.PUBLIC_URL + "/images/SAP/medium-eye.png"} className='eye-icon' alt="eye" />
                <span>
                    Total Views: {totalViews} &nbsp; | &nbsp; Unique Views: {totalUserViews}
                </span>
            </div>}
        </>
    )
}

export default Analytics